import { RootState } from "../store";

export const clubSelector = (state: RootState) => state.club;

